
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirece54"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirece54"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6Ceg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d115a573b5df29f$export$2e2bcd8739ae039);

var $dERkw = parcelRequire("dERkw");
class $4d115a573b5df29f$export$2e2bcd8739ae039 extends (0, $dERkw.default) {
    constructor(p){
        p.tagName = "section";
        super(p);
    }
}

});
parcelRegister("dERkw", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f186100d3e5650a$export$2e2bcd8739ae039);

var $kt4nd = parcelRequire("kt4nd");

var $h9Oct = parcelRequire("h9Oct");

var $iuUFI = parcelRequire("iuUFI");

var $4V0DF = parcelRequire("4V0DF");

var $hU1RT = parcelRequire("hU1RT");
class $9f186100d3e5650a$export$2e2bcd8739ae039 {
    setText(pText) {
        this._text = pText;
        if (this._DOMElement) this._DOMElement.textContent = pText;
    }
    setHTML(pHTML) {
        this._html = pHTML;
        if (this._DOMElement) this._DOMElement.innerHTML = pHTML;
    }
    getText() {
        return this._text;
    }
    getElementId() {
        if (!window.ED_DOM_MAP) window.ED_DOM_MAP = new Map();
        if (!window.ED_DOM_MAP.has(this.constructor.name)) {
            window.ED_DOM_MAP.set(this.constructor.name, 1);
            return this.constructor.name + "_1";
        }
        let counter = window.ED_DOM_MAP.get(this.constructor.name) + 1;
        window.ED_DOM_MAP.set(this.constructor.name, counter);
        return this.constructor.name + "_" + counter;
    }
    setParent(pParent) {
        this._EDParent = pParent;
    }
    getDOMId() {
        return this.dataset.getDOMId();
    }
    createElement() {
        return document.createElement(this._tagName);
    }
    render() {
        if (!this._DOMElement) {
            if (!this._tagName) throw "ED_DOMElement requires a tagName";
            if (!this._isRoot) this._DOMParent = this._EDParent._DOMElement;
            this._DOMElement = this.createElement();
            this.classList.render();
            this.attrib.render();
            this.dataset.render();
            this.eventListener.render();
            if (typeof this._text !== 'undefined') this._DOMElement.innerText = this._text;
            if (typeof this._html !== 'undefined') this._DOMElement.innerHTML = this._html;
            this._DOMParent.appendChild(this._DOMElement);
            this.children.render();
            window.VDOMMAP.set(this.getDOMId(), this);
            this.afterRender();
            return this._DOMElement;
        }
        this.children.forEach((element)=>{
            element.render(this.DOMElement);
        });
        return this.DOMElement;
    }
    afterUnrender(pDomId) {}
    unrender() {
        if (this._DOMElement) {
            const domId = this.getDOMId();
            this.children.unrender();
            window.VDOMMAP.delete(domId);
            this._DOMElement.remove();
            this._DOMElement = undefined;
            this.afterUnrender(domId);
        }
    }
    remove() {
        const domId = this.getDOMId();
        this.unrender();
        if (!this._isRoot) this._EDParent.children.remove(domId);
    }
    getChildInstance(pAppend) {
        return new (0, $hU1RT.default)(this, pAppend);
    }
    afterRender() {}
    constructor(p){
        p.text = p.append ? undefined : p.text;
        this._tagName = p.tagName;
        this.classList = new (0, $kt4nd.default)(this, p.class);
        this.attrib = new (0, $h9Oct.default)(this, p.attrib);
        this.dataset = new (0, $iuUFI.default)(this, p.dataset);
        this.eventListener = new (0, $4V0DF.default)(this, p.events);
        this.children = this.getChildInstance(p.append);
        this.dataset.add("eddomid", this.getElementId());
        this.dataset.add("objectid", p.objectId);
        this.attrib.add("tabindex", p.tabIndex);
        this.attrib.add("id", p.id);
        if (p.parent && p.parent instanceof Element) {
            this._isRoot = true;
            this._DOMParent = p.parent;
            if (p.initRoot != false) this._DOMParent.innerHTML = null;
            if (!window.VDOMMAP) window.VDOMMAP = new Map();
        }
        if (p.store) p.store(this);
        this.setText(p.text);
        if (p.html) this.setHTML(p.html);
    }
}

});
parcelRegister("kt4nd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee69e88d3fb1c984$export$2e2bcd8739ae039);
class $ee69e88d3fb1c984$export$2e2bcd8739ae039 {
    add(pClass) {
        if (!pClass) return;
        if (Array.isArray(pClass)) {
            pClass.forEach((className)=>{
                this.addSingle(className);
            });
            return;
        }
        this.addSingle(pClass);
    }
    addSingle(pClass) {
        this._classList.push(pClass);
        if (this._parent._DOMElement) this._parent._DOMElement.classList.add(pClass);
    }
    has(pClass) {
        return this._classList.indexOf(pClass) > -1;
    }
    remove(pClass) {
        const index = this._classList.indexOf(pClass);
        if (index > -1) this._classList.splice(index, 1);
        if (this._parent._DOMElement) this._parent._DOMElement.classList.remove(pClass);
    }
    clear() {
        this._classList = new Array();
        if (this._parent._DOMElement) this.clearDom();
    }
    clearDom() {
        var classList = this._parent._DOMElement.classList;
        while(classList.length > 0)classList.remove(classList.item(0));
    }
    sync() {
        if (this._parent._DOMElement) {
            this.clearDom();
            this.remder();
        }
    }
    render() {
        this._classList.forEach((elClass)=>{
            this._parent._DOMElement.classList.add(elClass);
        });
    }
    constructor(pParent, pClass){
        this._parent = pParent;
        this._classList = new Array();
        if (pClass) {
            pClass = Array.isArray(pClass) ? pClass : pClass.replace(/ /g, "").split(",");
            pClass.forEach((elClass)=>{
                this.add(elClass);
            });
        }
    }
}

});

parcelRegister("h9Oct", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7da37a09189b176$export$2e2bcd8739ae039);
class $c7da37a09189b176$export$2e2bcd8739ae039 {
    add(pName, pValue) {
        if (typeof pValue != "undefined") {
            this._attribList.set(pName, pValue);
            if (this._parent._DOMElement) this._parent._DOMElement.setAttribute(pName, pValue);
        }
    }
    has(pName) {
        return this._attribList.has(pName);
    }
    remove(pName) {
        this._attribList.delete(pName);
        if (this._parent._DOMElement) this._parent._DOMElement.removeAttribute(pName);
    }
    get(pName) {
        return this._attribList.get(pName);
    }
    render() {
        this._attribList.forEach((value, name)=>{
            this._parent._DOMElement.setAttribute(name, value);
        });
    }
    constructor(pParent, pAttrib){
        this._parent = pParent;
        this._attribList = new Map();
        if (pAttrib && typeof pAttrib === 'object' && pAttrib !== null) Object.entries(pAttrib).forEach(([name, value])=>{
            this.add(name, value);
        });
    }
}

});

parcelRegister("iuUFI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d776fd33dfaac8e9$export$2e2bcd8739ae039);
class $d776fd33dfaac8e9$export$2e2bcd8739ae039 {
    add(pName, pValue) {
        if (typeof pValue != "undefined") {
            this._dataset.set(pName, pValue);
            if (this._parent._DOMElement) this._parent._DOMElement.dataset[pName] = pValue;
        }
    }
    has(pName) {
        return this._dataset.has(pName);
    }
    get(pName) {
        return this._dataset.get(pName);
    }
    remove(pName) {
        this._dataset.delete(pName);
        if (this._parent._DOMElement) delete this._parent._DOMElement.dataset[pName];
    }
    render() {
        this._dataset.forEach((value, name)=>{
            this._parent._DOMElement.dataset[name] = value;
        });
    }
    getDOMId() {
        return this.get("eddomid");
    }
    constructor(pParent, pDataset){
        this._parent = pParent;
        this._dataset = new Map();
        if (pDataset && typeof pDataset === 'object' && pDataset !== null) Object.entries(pDataset).forEach(([name, value])=>{
            this.add(name, value);
        });
    }
}

});

parcelRegister("4V0DF", function(module, exports) {

$parcel$export(module.exports, "default", () => $394cfb23cf46a437$export$2e2bcd8739ae039);
class $394cfb23cf46a437$export$2e2bcd8739ae039 {
    add(pName, pValue) {
        if (typeof pValue != "undefined") {
            this._events.set(pName, pValue);
            if (this._parent._DOMElement) this._parent._DOMElement.addEventListener(pName, pValue);
        }
    }
    has(pName) {
        return this._events.has(pName);
    }
    remove(pName) {
        const value = this._events.get(pName);
        if (value) {
            this._events.delete(pName);
            if (this._parent._DOMElement) this._parent._DOMElement.removeEventListener(pName, value);
        }
    }
    render() {
        this._events.forEach((value, name)=>{
            this._parent._DOMElement.addEventListener(name, value);
        });
    }
    constructor(pParent, pListeners){
        this._parent = pParent;
        this._events = new Map();
        if (pListeners && typeof pListeners === 'object' && pListeners !== null) Object.entries(pListeners).forEach(([name, value])=>{
            this.add(name, value);
        });
    }
}

});

parcelRegister("hU1RT", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0891d9af649d716$export$2e2bcd8739ae039);
class $d0891d9af649d716$export$2e2bcd8739ae039 {
    validateElement(pElement) {
        return true;
    }
    appendElement(pElement) {
        if (pElement && this.validateElement(pElement)) {
            pElement.setParent(this._parent);
            this._children.set(pElement.getDOMId(), pElement);
            if (this._parent._DOMElement) pElement.render();
            return pElement.getDOMId();
        }
    }
    append(pElement) {
        if (pElement) {
            pElement = Array.isArray(pElement) ? pElement : new Array(pElement);
            pElement.forEach((el)=>{
                this.appendElement(el);
            });
        }
    }
    has(pName) {
        return this._children.has(pName);
    }
    remove(pName) {
        this._children.delete(pName);
    }
    get(pName) {
        return this._children.get(pName);
    }
    render() {
        this._children.forEach((element, name)=>{
            element.render();
        });
    }
    unrender() {
        this._children.forEach((element)=>{
            element.unrender();
        });
        this._children.clear();
    }
    count() {
        return this._children.size;
    }
    getKeyArray() {
        return Array.from(this._children.keys());
    }
    getById(pId) {
        const keys = this.getKeyArray();
        if (keys[pId]) return this._children.get(keys[pId]);
    }
    constructor(pParent, pAppend){
        this._parent = pParent;
        this._children = new Map();
        this.append(pAppend);
    }
}

});



parcelRegister("1ssWT", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fedca402199f0f$export$2e2bcd8739ae039);

var $dERkw = parcelRequire("dERkw");
class $10fedca402199f0f$export$2e2bcd8739ae039 extends (0, $dERkw.default) {
    constructor(p){
        p.tagName = "div";
        super(p);
        if (p.role) this.attrib.add("role", p.role);
    }
}

});

parcelRegister("kmaCx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ed1e19c35ad6445a$export$2e2bcd8739ae039);


var $29IrZ = parcelRequire("29IrZ");
class $ed1e19c35ad6445a$export$2e2bcd8739ae039 extends (0, $29IrZ.default) {
    constructor(p){
        super(p);
        this.classList.add("ed-spinner");
        this.classList.add("ed-hidden");
        this.children.append(new (0, $29IrZ.default)({
            class: "loader"
        }));
        window.addEventListener("spinnerEvent", (pEvt)=>{
            if (pEvt.detail.id !== p.spinnerId) return;
            if (pEvt.detail.cmd === "show") {
                this.classList.remove("ed-hidden");
                return;
            }
            this.classList.add("ed-hidden");
        });
    }
}

});
parcelRegister("29IrZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $191ee6f3509fc1f8$export$2e2bcd8739ae039);

var $dERkw = parcelRequire("dERkw");
class $191ee6f3509fc1f8$export$2e2bcd8739ae039 extends (0, $dERkw.default) {
    constructor(p){
        p.tagName = "span";
        super(p);
    }
}

});


parcelRegister("dPc8B", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1097411a7b41172$export$2e2bcd8739ae039);

var $cFVFb = parcelRequire("cFVFb");

var $9CePy = parcelRequire("9CePy");
class $a1097411a7b41172$export$2e2bcd8739ae039 {
    logOut() {
        window.localStorage.removeItem(this.jwtKey);
        delete this.apiJWT;
        (0, $9CePy.default).logout();
    }
    isSoftLoggedIn() {
        if (!this.apiJWT) {
            (0, $9CePy.default).logout();
            return false;
        }
        if (!this.apiJWT.isHardValid()) {
            this.logOut();
            return false;
        }
        (0, $9CePy.default).login(this);
        return true;
    }
    isLoggedIn() {
        return this.isSoftLoggedIn() && this.apiJWT.isValid();
    }
    getUser() {
        if (this.isSoftLoggedIn()) return this.apiJWT.body;
    }
    hasRole(pRole) {
        if (this.isSoftLoggedIn()) return this.apiJWT.hasRole(pRole);
    }
    getAuthHeader() {
        if (this.isSoftLoggedIn()) return "Bearer " + this.apiJWT.jwt;
    }
    getJWT() {
        if (this.isSoftLoggedIn()) return this.apiJWT.jwt;
    }
    logIn(pJWT) {
        this.logOut();
        const jwt = new (0, $cFVFb.default)(pJWT);
        if (jwt.isValid()) {
            window.localStorage.setItem(this.jwtKey, pJWT);
            this.apiJWT = jwt;
            (0, $9CePy.default).login(this);
            return true;
        }
    }
    constructor(p){
        this.jwtKey = p.jwtKey;
        const jwt = window.localStorage.getItem(this.jwtKey);
        if (!jwt || jwt === "undefined") {
            this.logOut();
            return;
        }
        this.apiJWT = new (0, $cFVFb.default)(jwt);
        this.isSoftLoggedIn();
    }
}

});
parcelRegister("cFVFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $93a60b1c623d33f1$export$2e2bcd8739ae039);
class $93a60b1c623d33f1$export$2e2bcd8739ae039 {
    isHardValid() {
        return this.body.HardExp - 60 > Math.floor(Date.now() / 1000);
    }
    isValid() {
        return this.isHardValid() && this.body.Exp - 60 > Math.floor(Date.now() / 1000);
    }
    hasRole(pRole) {
        if (this.isHardValid()) return this.body.Roles.includes(pRole);
    }
    constructor(pJWT){
        if (pJWT) {
            let jwt = pJWT.replaceAll("-", "+");
            jwt = jwt.replaceAll("_", "/");
            const jwtArray = jwt.split(".");
            const body = atob(jwtArray[1]);
            const bodyJSON = JSON.parse(body);
            this.jwt = pJWT;
            this.body = bodyJSON;
        }
    }
}

});

parcelRegister("9CePy", function(module, exports) {

$parcel$export(module.exports, "default", () => $70032aae9d78ea5b$export$2e2bcd8739ae039);
class $70032aae9d78ea5b$export$2e2bcd8739ae039 extends CustomEvent {
    static login(pUser) {
        const authEvent = new $70032aae9d78ea5b$export$2e2bcd8739ae039({
            type: "login",
            user: pUser
        });
        window.dispatchEvent(authEvent);
    }
    static logout() {
        const authEvent = new $70032aae9d78ea5b$export$2e2bcd8739ae039({
            type: "logout"
        });
        window.dispatchEvent(authEvent);
    }
    constructor(p){
        super("authEvent", {
            detail: {
                type: p.type,
                user: p.user
            }
        });
    }
}

});


parcelRegister("bJkGa", function(module, exports) {

$parcel$export(module.exports, "default", () => $88a3f0189767adc2$export$2e2bcd8739ae039);
var $88a3f0189767adc2$export$2e2bcd8739ae039 = {
    maxMobile: 768,
    appURL: "https://edlogix.com/",
    autoUpdate: 3600000,
    favIcon: "images/EdLogixIcon.png",
    routerEndPoint: "edl/url",
    reqAuth: false,
    authURL: "/login",
    unauthURL: "/unathorized",
    origins: {
        "https://wp.edlogix.com:1234": {
            analytics: {
                isActive: true,
                debug: true,
                tag: "G-N5XY11DNHX",
                config: {
                    "send_page_view": false
                }
            },
            apiClient: {
                server: "https://api.birdhouse-demos.com",
                auth: {
                    jwtKey: "jwt",
                    endPoint: "edl/auth"
                },
                headers: {
                    "x-siteid": 9010
                },
                options: {
                    croddDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    credentials: "include",
                    cache: "no-store"
                }
            },
            static: "https://staticlocal.edlogix.com/edl/",
            isDevEnv: true
        },
        default: {
            analytics: {
                isActive: true,
                debug: false,
                tag: "G-9P34VCTTX5",
                config: {
                    "send_page_view": false
                }
            },
            apiClient: {
                server: "https://api.birdhouse-demos.com",
                auth: {
                    jwtKey: "jwt",
                    endPoint: "edl/auth"
                },
                options: {
                    croddDomain: true,
                    xhrFields: {
                        withCredentials: true
                    },
                    credentials: "include",
                    cache: "no-store"
                }
            },
            static: "https://static.edlogix.com/",
            isDevEnv: false
        }
    },
    routes: {
        form: {
            endPoint: "edl/form",
            resultId: "SiteForm"
        }
    },
    menus: {
        header: {
            name: "Main Menu",
            class2: [
                "ed-main-menu"
            ],
            options: [
                {
                    name: "Navigation Menu",
                    options: [
                        {
                            title: "Web Development",
                            href: "/web-development/"
                        },
                        {
                            title: "Digital Marketing",
                            href: "/digital-marketing/"
                        },
                        {
                            title: "Cyber Security",
                            href: "/cybersecurity/"
                        },
                        {
                            title: "About Us",
                            href: "/about/"
                        }
                    ]
                }
            ]
        },
        footer: {
            name: "Menu",
            options: [
                {
                    title: "Web Development",
                    href: "/web-development/"
                },
                {
                    title: "Digital Marketing",
                    href: "/digital-marketing/"
                },
                {
                    title: "Cyber Security",
                    href: "/cybersecurity/"
                },
                {
                    title: "About Us",
                    href: "/about/"
                }
            ]
        },
        locations: {
            name: "Locations",
            options: [
                {
                    title: "Houston, TX - USA",
                    email: "us@edlogix.com"
                },
                {
                    title: "Mexico City - MX",
                    email: "mx@edlogix.com"
                }
            ]
        }
    }
};

});

parcelRegister("1sSWl", function(module, exports) {

$parcel$export(module.exports, "default", () => $111305f091f1a542$export$2e2bcd8739ae039);
var $111305f091f1a542$export$2e2bcd8739ae039 = "1.03.02";

});

parcelRegister("kgaiw", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebfd4a33386c1a02$export$2e2bcd8739ae039);

var $afarQ = parcelRequire("afarQ");

var $dPc8B = parcelRequire("dPc8B");

var $bt9VR = parcelRequire("bt9VR");
class $ebfd4a33386c1a02$export$2e2bcd8739ae039 {
    async getAuthHeader() {
        if (!this.apiUser.isSoftLoggedIn()) return null;
        if (this.apiUser.isLoggedIn()) return this.apiUser.getAuthHeader();
        return this.fetchAuth({
            JWT: this.apiUser.getJWT()
        }).then((status)=>{
            if (status) return this.apiUser.getAuthHeader();
        }).catch((error)=>{
            this.apiUser.logOut();
        });
    }
    async fetchAuth(p) {
        const params = this.getFetchParams({
            body: p,
            method: "post",
            endPoint: this.auth.endPoint,
            server: this.auth.server || this.server
        });
        (0, $bt9VR.default).show(this.spinnerId);
        return fetch(params.url, params.options).then((result)=>{
            if (!result.ok) {
                (0, $bt9VR.default).hide(this.spinnerId);
                const error = new Error(result.status);
                error.code = result.status;
                throw error;
            }
            return result.json();
        }).then((jwt)=>{
            if (jwt?.Results?.JWT?.Payload?.JWT) {
                (0, $bt9VR.default).hide(this.spinnerId);
                return this.apiUser.logIn(jwt.Results.JWT.Payload.JWT);
            }
        }).catch((jwtError)=>{
            (0, $bt9VR.default).hide(this.spinnerId);
            const error = new Error(jwtError);
            error.code = jwtError.code;
            error.type = "auth";
            throw error;
        });
    }
    getFetchParams(p) {
        const src = Object.assign({}, p);
        src.server = typeof p.server === "undefined" ? this.server : p.server;
        src.filter = p.filter || {};
        src.filter = typeof p.filter === "undefined" ? {} : Object.assign({}, p.filter);
        src.filter.preview = true;
        src.method = p.method || "get";
        src.headers = p.headers || {};
        src.options = p.options || {};
        src.body = p.body || {};
        src.isJSON = typeof p.isJSON === "undefined" ? true : p.isJSON;
        const params = {};
        params.options = Object.assign({}, this.options, src.options);
        params.options.headers = Object.assign({}, this.headers, src.headers);
        params.options.headers.xfp = this.fp;
        params.options.method = src.method;
        if (src.method !== "get") {
            params.options.body = src.body;
            if (src.isJSON) {
                params.options.headers["content-type"] = "application/json";
                params.options.body = JSON.stringify(src.body);
            }
        }
        params.url = src.server + "/" + src.endPoint + "?" + new URLSearchParams(src.filter);
        return params;
    }
    async fetch(p) {
        const params = this.getFetchParams(p);
        (0, $bt9VR.default).show(this.spinnerId);
        return this.getAuthHeader().then((jwt)=>{
            if (jwt) params.options.headers.authorizationalt = jwt;
            return fetch(params.url, params.options).then((result)=>{
                if (!result.ok) {
                    const error = new Error(result.status);
                    error.code = result.status;
                    throw error;
                }
                (0, $bt9VR.default).hide(this.spinnerId);
                return result.json();
            }).catch((resultError)=>{
                (0, $bt9VR.default).hide(this.spinnerId);
                const error = new Error(resultError);
                error.code = resultError.code;
                error.type = "fetch";
                throw error;
            });
        });
    }
    constructor(p){
        Object.entries(p).forEach(([id, value])=>{
            this[id] = value;
        });
        this.headers = this.headers || {};
        this.fp = (0, $afarQ.default).get();
        this.apiUser = new (0, $dPc8B.default)({
            jwtKey: p.auth.jwtKey
        });
        this.spinnerId = p.spinnerId || "main";
    }
}

});
parcelRegister("afarQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $775368d9ab7cc120$export$2e2bcd8739ae039);

var $2sZlY = parcelRequire("2sZlY");
class $775368d9ab7cc120$export$2e2bcd8739ae039 {
    static get() {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        const txt = "i9asdm..$#po((^@KbXrww!~cza";
        ctx.textBaseline = "top";
        ctx.font = "18px 'Arial'";
        ctx.textBaseline = "alphabetic";
        ctx.rotate(.05);
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText(txt, 2, 15);
        ctx.fillStyle = "rgba(102, 200, 0, 0.7)";
        ctx.fillText(navigator.userAgent, 4, 27);
        ctx.shadowBlur = 10;
        ctx.shadowColor = "blue";
        ctx.fillRect(-20, 10, 234, 5);
        const fpString = canvas.toDataURL();
        if (fpString.length === 0) return null;
        return (0, $2sZlY.md5)(fpString);
    }
}

});
parcelRegister("2sZlY", function(module, exports) {


/**
 * [js-md5]{@link https://github.com/emn178/js-md5}
 *
 * @namespace md5
 * @version 0.8.3
 * @author Chen, Yi-Cyuan [emn178@gmail.com]
 * @copyright Chen, Yi-Cyuan 2014-2023
 * @license MIT
 */ (function() {
    'use strict';
    var INPUT_ERROR = 'input is invalid type';
    var FINALIZE_ERROR = 'finalize already called';
    var WINDOW = typeof window === 'object';
    var root = WINDOW ? window : {};
    if (root.JS_MD5_NO_WINDOW) WINDOW = false;
    var WEB_WORKER = !WINDOW && typeof self === 'object';
    var NODE_JS = !root.JS_MD5_NO_NODE_JS && false;
    if (NODE_JS) root = $parcel$global;
    else if (WEB_WORKER) root = self;
    var COMMON_JS = !root.JS_MD5_NO_COMMON_JS && true && module.exports;
    var AMD = typeof define === 'function' && define.amd;
    var ARRAY_BUFFER = !root.JS_MD5_NO_ARRAY_BUFFER && typeof ArrayBuffer !== 'undefined';
    var HEX_CHARS = '0123456789abcdef'.split('');
    var EXTRA = [
        128,
        32768,
        8388608,
        -2147483648
    ];
    var SHIFT = [
        0,
        8,
        16,
        24
    ];
    var OUTPUT_TYPES = [
        'hex',
        'array',
        'digest',
        'buffer',
        'arrayBuffer',
        'base64'
    ];
    var BASE64_ENCODE_CHAR = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'.split('');
    var blocks = [], buffer8;
    if (ARRAY_BUFFER) {
        var buffer = new ArrayBuffer(68);
        buffer8 = new Uint8Array(buffer);
        blocks = new Uint32Array(buffer);
    }
    var isArray = Array.isArray;
    if (root.JS_MD5_NO_NODE_JS || !isArray) isArray = function(obj) {
        return Object.prototype.toString.call(obj) === '[object Array]';
    };
    var isView = ArrayBuffer.isView;
    if (ARRAY_BUFFER && (root.JS_MD5_NO_ARRAY_BUFFER_IS_VIEW || !isView)) isView = function(obj) {
        return typeof obj === 'object' && obj.buffer && obj.buffer.constructor === ArrayBuffer;
    };
    // [message: string, isString: bool]
    var formatMessage = function(message) {
        var type = typeof message;
        if (type === 'string') return [
            message,
            true
        ];
        if (type !== 'object' || message === null) throw new Error(INPUT_ERROR);
        if (ARRAY_BUFFER && message.constructor === ArrayBuffer) return [
            new Uint8Array(message),
            false
        ];
        if (!isArray(message) && !isView(message)) throw new Error(INPUT_ERROR);
        return [
            message,
            false
        ];
    };
    /**
   * @method hex
   * @memberof md5
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hex('The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.digest('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.array('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.arrayBuffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.buffer('The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.base64('The quick brown fox jumps over the lazy dog');
   */ var createOutputMethod = function(outputType) {
        return function(message) {
            return new Md5(true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5
   * @description Create Md5 object
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.create();
   */ /**
   * @method update
   * @memberof md5
   * @description Create and update Md5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @example
   * var hash = md5.update('The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.create();
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createMethod = function() {
        var method = createOutputMethod('hex');
        if (NODE_JS) method = nodeWrap(method);
        method.create = function() {
            return new Md5();
        };
        method.update = function(message) {
            return method.create().update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createOutputMethod(type);
        }
        return method;
    };
    var nodeWrap = function(method) {
        var crypto = (parcelRequire("kjyEk"));
        var Buffer = (parcelRequire("kjyEk")).Buffer;
        var bufferFrom;
        if (Buffer.from && !root.JS_MD5_NO_BUFFER_FROM) bufferFrom = Buffer.from;
        else bufferFrom = function(message) {
            return new Buffer(message);
        };
        var nodeMethod = function(message) {
            if (typeof message === 'string') return crypto.createHash('md5').update(message, 'utf8').digest('hex');
            else {
                if (message === null || message === undefined) throw new Error(INPUT_ERROR);
                else if (message.constructor === ArrayBuffer) message = new Uint8Array(message);
            }
            if (isArray(message) || isView(message) || message.constructor === Buffer) return crypto.createHash('md5').update(bufferFrom(message)).digest('hex');
            else return method(message);
        };
        return nodeMethod;
    };
    /**
   * @namespace md5.hmac
   */ /**
   * @method hex
   * @memberof md5.hmac
   * @description Output hash as hex string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} Hex string
   * @example
   * md5.hmac.hex('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * md5.hmac('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method digest
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.digest('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method array
   * @memberof md5.hmac
   * @description Output hash as bytes array
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Array} Bytes array
   * @example
   * md5.hmac.array('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method arrayBuffer
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.arrayBuffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof md5.hmac
   * @description Output hash as ArrayBuffer
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {ArrayBuffer} ArrayBuffer
   * @example
   * md5.hmac.buffer('key', 'The quick brown fox jumps over the lazy dog');
   */ /**
   * @method base64
   * @memberof md5.hmac
   * @description Output hash as base64 string
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {String} base64 string
   * @example
   * md5.hmac.base64('key', 'The quick brown fox jumps over the lazy dog');
   */ var createHmacOutputMethod = function(outputType) {
        return function(key, message) {
            return new HmacMd5(key, true).update(message)[outputType]();
        };
    };
    /**
   * @method create
   * @memberof md5.hmac
   * @description Create HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.create('key');
   */ /**
   * @method update
   * @memberof md5.hmac
   * @description Create and update HmacMd5 object
   * @param {String|Array|Uint8Array|ArrayBuffer} key key
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {HmacMd5} HmacMd5 object.
   * @example
   * var hash = md5.hmac.update('key', 'The quick brown fox jumps over the lazy dog');
   * // equal to
   * var hash = md5.hmac.create('key');
   * hash.update('The quick brown fox jumps over the lazy dog');
   */ var createHmacMethod = function() {
        var method = createHmacOutputMethod('hex');
        method.create = function(key) {
            return new HmacMd5(key);
        };
        method.update = function(key, message) {
            return method.create(key).update(message);
        };
        for(var i = 0; i < OUTPUT_TYPES.length; ++i){
            var type = OUTPUT_TYPES[i];
            method[type] = createHmacOutputMethod(type);
        }
        return method;
    };
    /**
   * Md5 class
   * @class Md5
   * @description This is internal class.
   * @see {@link md5.create}
   */ function Md5(sharedMemory) {
        if (sharedMemory) {
            blocks[0] = blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            this.blocks = blocks;
            this.buffer8 = buffer8;
        } else if (ARRAY_BUFFER) {
            var buffer = new ArrayBuffer(68);
            this.buffer8 = new Uint8Array(buffer);
            this.blocks = new Uint32Array(buffer);
        } else this.blocks = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        this.h0 = this.h1 = this.h2 = this.h3 = this.start = this.bytes = this.hBytes = 0;
        this.finalized = this.hashed = false;
        this.first = true;
    }
    /**
   * @method update
   * @memberof Md5
   * @instance
   * @description Update hash
   * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
   * @returns {Md5} Md5 object.
   * @see {@link md5.update}
   */ Md5.prototype.update = function(message) {
        if (this.finalized) throw new Error(FINALIZE_ERROR);
        var result = formatMessage(message);
        message = result[0];
        var isString = result[1];
        var code, index = 0, i, length = message.length, blocks = this.blocks;
        var buffer8 = this.buffer8;
        while(index < length){
            if (this.hashed) {
                this.hashed = false;
                blocks[0] = blocks[16];
                blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
            }
            if (isString) {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) buffer8[i++] = code;
                    else if (code < 0x800) {
                        buffer8[i++] = 0xc0 | code >>> 6;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else if (code < 0xd800 || code >= 0xe000) {
                        buffer8[i++] = 0xe0 | code >>> 12;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        buffer8[i++] = 0xf0 | code >>> 18;
                        buffer8[i++] = 0x80 | code >>> 12 & 0x3f;
                        buffer8[i++] = 0x80 | code >>> 6 & 0x3f;
                        buffer8[i++] = 0x80 | code & 0x3f;
                    }
                }
                else for(i = this.start; index < length && i < 64; ++index){
                    code = message.charCodeAt(index);
                    if (code < 0x80) blocks[i >>> 2] |= code << SHIFT[i++ & 3];
                    else if (code < 0x800) {
                        blocks[i >>> 2] |= (0xc0 | code >>> 6) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else if (code < 0xd800 || code >= 0xe000) {
                        blocks[i >>> 2] |= (0xe0 | code >>> 12) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    } else {
                        code = 0x10000 + ((code & 0x3ff) << 10 | message.charCodeAt(++index) & 0x3ff);
                        blocks[i >>> 2] |= (0xf0 | code >>> 18) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 12 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code >>> 6 & 0x3f) << SHIFT[i++ & 3];
                        blocks[i >>> 2] |= (0x80 | code & 0x3f) << SHIFT[i++ & 3];
                    }
                }
            } else {
                if (ARRAY_BUFFER) for(i = this.start; index < length && i < 64; ++index)buffer8[i++] = message[index];
                else for(i = this.start; index < length && i < 64; ++index)blocks[i >>> 2] |= message[index] << SHIFT[i++ & 3];
            }
            this.lastByteIndex = i;
            this.bytes += i - this.start;
            if (i >= 64) {
                this.start = i - 64;
                this.hash();
                this.hashed = true;
            } else this.start = i;
        }
        if (this.bytes > 4294967295) {
            this.hBytes += this.bytes / 4294967296 << 0;
            this.bytes = this.bytes % 4294967296;
        }
        return this;
    };
    Md5.prototype.finalize = function() {
        if (this.finalized) return;
        this.finalized = true;
        var blocks = this.blocks, i = this.lastByteIndex;
        blocks[i >>> 2] |= EXTRA[i & 3];
        if (i >= 56) {
            if (!this.hashed) this.hash();
            blocks[0] = blocks[16];
            blocks[16] = blocks[1] = blocks[2] = blocks[3] = blocks[4] = blocks[5] = blocks[6] = blocks[7] = blocks[8] = blocks[9] = blocks[10] = blocks[11] = blocks[12] = blocks[13] = blocks[14] = blocks[15] = 0;
        }
        blocks[14] = this.bytes << 3;
        blocks[15] = this.hBytes << 3 | this.bytes >>> 29;
        this.hash();
    };
    Md5.prototype.hash = function() {
        var a, b, c, d, bc, da, blocks = this.blocks;
        if (this.first) {
            a = blocks[0] - 680876937;
            a = (a << 7 | a >>> 25) - 271733879 << 0;
            d = (-1732584194 ^ a & 2004318071) + blocks[1] - 117830708;
            d = (d << 12 | d >>> 20) + a << 0;
            c = (-271733879 ^ d & (a ^ -271733879)) + blocks[2] - 1126478375;
            c = (c << 17 | c >>> 15) + d << 0;
            b = (a ^ c & (d ^ a)) + blocks[3] - 1316259209;
            b = (b << 22 | b >>> 10) + c << 0;
        } else {
            a = this.h0;
            b = this.h1;
            c = this.h2;
            d = this.h3;
            a += (d ^ b & (c ^ d)) + blocks[0] - 680876936;
            a = (a << 7 | a >>> 25) + b << 0;
            d += (c ^ a & (b ^ c)) + blocks[1] - 389564586;
            d = (d << 12 | d >>> 20) + a << 0;
            c += (b ^ d & (a ^ b)) + blocks[2] + 606105819;
            c = (c << 17 | c >>> 15) + d << 0;
            b += (a ^ c & (d ^ a)) + blocks[3] - 1044525330;
            b = (b << 22 | b >>> 10) + c << 0;
        }
        a += (d ^ b & (c ^ d)) + blocks[4] - 176418897;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[5] + 1200080426;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[6] - 1473231341;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[7] - 45705983;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[8] + 1770035416;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[9] - 1958414417;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[10] - 42063;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[11] - 1990404162;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (d ^ b & (c ^ d)) + blocks[12] + 1804603682;
        a = (a << 7 | a >>> 25) + b << 0;
        d += (c ^ a & (b ^ c)) + blocks[13] - 40341101;
        d = (d << 12 | d >>> 20) + a << 0;
        c += (b ^ d & (a ^ b)) + blocks[14] - 1502002290;
        c = (c << 17 | c >>> 15) + d << 0;
        b += (a ^ c & (d ^ a)) + blocks[15] + 1236535329;
        b = (b << 22 | b >>> 10) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[1] - 165796510;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[6] - 1069501632;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[11] + 643717713;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[0] - 373897302;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[5] - 701558691;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[10] + 38016083;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[15] - 660478335;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[4] - 405537848;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[9] + 568446438;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[14] - 1019803690;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[3] - 187363961;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[8] + 1163531501;
        b = (b << 20 | b >>> 12) + c << 0;
        a += (c ^ d & (b ^ c)) + blocks[13] - 1444681467;
        a = (a << 5 | a >>> 27) + b << 0;
        d += (b ^ c & (a ^ b)) + blocks[2] - 51403784;
        d = (d << 9 | d >>> 23) + a << 0;
        c += (a ^ b & (d ^ a)) + blocks[7] + 1735328473;
        c = (c << 14 | c >>> 18) + d << 0;
        b += (d ^ a & (c ^ d)) + blocks[12] - 1926607734;
        b = (b << 20 | b >>> 12) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[5] - 378558;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[8] - 2022574463;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[11] + 1839030562;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[14] - 35309556;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[1] - 1530992060;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[4] + 1272893353;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[7] - 155497632;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[10] - 1094730640;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[13] + 681279174;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[0] - 358537222;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[3] - 722521979;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[6] + 76029189;
        b = (b << 23 | b >>> 9) + c << 0;
        bc = b ^ c;
        a += (bc ^ d) + blocks[9] - 640364487;
        a = (a << 4 | a >>> 28) + b << 0;
        d += (bc ^ a) + blocks[12] - 421815835;
        d = (d << 11 | d >>> 21) + a << 0;
        da = d ^ a;
        c += (da ^ b) + blocks[15] + 530742520;
        c = (c << 16 | c >>> 16) + d << 0;
        b += (da ^ c) + blocks[2] - 995338651;
        b = (b << 23 | b >>> 9) + c << 0;
        a += (c ^ (b | ~d)) + blocks[0] - 198630844;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[7] + 1126891415;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[14] - 1416354905;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[5] - 57434055;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[12] + 1700485571;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[3] - 1894986606;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[10] - 1051523;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[1] - 2054922799;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[8] + 1873313359;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[15] - 30611744;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[6] - 1560198380;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[13] + 1309151649;
        b = (b << 21 | b >>> 11) + c << 0;
        a += (c ^ (b | ~d)) + blocks[4] - 145523070;
        a = (a << 6 | a >>> 26) + b << 0;
        d += (b ^ (a | ~c)) + blocks[11] - 1120210379;
        d = (d << 10 | d >>> 22) + a << 0;
        c += (a ^ (d | ~b)) + blocks[2] + 718787259;
        c = (c << 15 | c >>> 17) + d << 0;
        b += (d ^ (c | ~a)) + blocks[9] - 343485551;
        b = (b << 21 | b >>> 11) + c << 0;
        if (this.first) {
            this.h0 = a + 1732584193 << 0;
            this.h1 = b - 271733879 << 0;
            this.h2 = c - 1732584194 << 0;
            this.h3 = d + 271733878 << 0;
            this.first = false;
        } else {
            this.h0 = this.h0 + a << 0;
            this.h1 = this.h1 + b << 0;
            this.h2 = this.h2 + c << 0;
            this.h3 = this.h3 + d << 0;
        }
    };
    /**
   * @method hex
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.hex();
   */ Md5.prototype.hex = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return HEX_CHARS[h0 >>> 4 & 0x0F] + HEX_CHARS[h0 & 0x0F] + HEX_CHARS[h0 >>> 12 & 0x0F] + HEX_CHARS[h0 >>> 8 & 0x0F] + HEX_CHARS[h0 >>> 20 & 0x0F] + HEX_CHARS[h0 >>> 16 & 0x0F] + HEX_CHARS[h0 >>> 28 & 0x0F] + HEX_CHARS[h0 >>> 24 & 0x0F] + HEX_CHARS[h1 >>> 4 & 0x0F] + HEX_CHARS[h1 & 0x0F] + HEX_CHARS[h1 >>> 12 & 0x0F] + HEX_CHARS[h1 >>> 8 & 0x0F] + HEX_CHARS[h1 >>> 20 & 0x0F] + HEX_CHARS[h1 >>> 16 & 0x0F] + HEX_CHARS[h1 >>> 28 & 0x0F] + HEX_CHARS[h1 >>> 24 & 0x0F] + HEX_CHARS[h2 >>> 4 & 0x0F] + HEX_CHARS[h2 & 0x0F] + HEX_CHARS[h2 >>> 12 & 0x0F] + HEX_CHARS[h2 >>> 8 & 0x0F] + HEX_CHARS[h2 >>> 20 & 0x0F] + HEX_CHARS[h2 >>> 16 & 0x0F] + HEX_CHARS[h2 >>> 28 & 0x0F] + HEX_CHARS[h2 >>> 24 & 0x0F] + HEX_CHARS[h3 >>> 4 & 0x0F] + HEX_CHARS[h3 & 0x0F] + HEX_CHARS[h3 >>> 12 & 0x0F] + HEX_CHARS[h3 >>> 8 & 0x0F] + HEX_CHARS[h3 >>> 20 & 0x0F] + HEX_CHARS[h3 >>> 16 & 0x0F] + HEX_CHARS[h3 >>> 28 & 0x0F] + HEX_CHARS[h3 >>> 24 & 0x0F];
    };
    /**
   * @method toString
   * @memberof Md5
   * @instance
   * @description Output hash as hex string
   * @returns {String} Hex string
   * @see {@link md5.hex}
   * @example
   * hash.toString();
   */ Md5.prototype.toString = Md5.prototype.hex;
    /**
   * @method digest
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.digest}
   * @example
   * hash.digest();
   */ Md5.prototype.digest = function() {
        this.finalize();
        var h0 = this.h0, h1 = this.h1, h2 = this.h2, h3 = this.h3;
        return [
            h0 & 0xFF,
            h0 >>> 8 & 0xFF,
            h0 >>> 16 & 0xFF,
            h0 >>> 24 & 0xFF,
            h1 & 0xFF,
            h1 >>> 8 & 0xFF,
            h1 >>> 16 & 0xFF,
            h1 >>> 24 & 0xFF,
            h2 & 0xFF,
            h2 >>> 8 & 0xFF,
            h2 >>> 16 & 0xFF,
            h2 >>> 24 & 0xFF,
            h3 & 0xFF,
            h3 >>> 8 & 0xFF,
            h3 >>> 16 & 0xFF,
            h3 >>> 24 & 0xFF
        ];
    };
    /**
   * @method array
   * @memberof Md5
   * @instance
   * @description Output hash as bytes array
   * @returns {Array} Bytes array
   * @see {@link md5.array}
   * @example
   * hash.array();
   */ Md5.prototype.array = Md5.prototype.digest;
    /**
   * @method arrayBuffer
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.arrayBuffer}
   * @example
   * hash.arrayBuffer();
   */ Md5.prototype.arrayBuffer = function() {
        this.finalize();
        var buffer = new ArrayBuffer(16);
        var blocks = new Uint32Array(buffer);
        blocks[0] = this.h0;
        blocks[1] = this.h1;
        blocks[2] = this.h2;
        blocks[3] = this.h3;
        return buffer;
    };
    /**
   * @method buffer
   * @deprecated This maybe confuse with Buffer in node.js. Please use arrayBuffer instead.
   * @memberof Md5
   * @instance
   * @description Output hash as ArrayBuffer
   * @returns {ArrayBuffer} ArrayBuffer
   * @see {@link md5.buffer}
   * @example
   * hash.buffer();
   */ Md5.prototype.buffer = Md5.prototype.arrayBuffer;
    /**
   * @method base64
   * @memberof Md5
   * @instance
   * @description Output hash as base64 string
   * @returns {String} base64 string
   * @see {@link md5.base64}
   * @example
   * hash.base64();
   */ Md5.prototype.base64 = function() {
        var v1, v2, v3, base64Str = '', bytes = this.array();
        for(var i = 0; i < 15;){
            v1 = bytes[i++];
            v2 = bytes[i++];
            v3 = bytes[i++];
            base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[(v1 << 4 | v2 >>> 4) & 63] + BASE64_ENCODE_CHAR[(v2 << 2 | v3 >>> 6) & 63] + BASE64_ENCODE_CHAR[v3 & 63];
        }
        v1 = bytes[i];
        base64Str += BASE64_ENCODE_CHAR[v1 >>> 2] + BASE64_ENCODE_CHAR[v1 << 4 & 63] + '==';
        return base64Str;
    };
    /**
   * HmacMd5 class
   * @class HmacMd5
   * @extends Md5
   * @description This is internal class.
   * @see {@link md5.hmac.create}
   */ function HmacMd5(key, sharedMemory) {
        var i, result = formatMessage(key);
        key = result[0];
        if (result[1]) {
            var bytes = [], length = key.length, index = 0, code;
            for(i = 0; i < length; ++i){
                code = key.charCodeAt(i);
                if (code < 0x80) bytes[index++] = code;
                else if (code < 0x800) {
                    bytes[index++] = 0xc0 | code >>> 6;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else if (code < 0xd800 || code >= 0xe000) {
                    bytes[index++] = 0xe0 | code >>> 12;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                } else {
                    code = 0x10000 + ((code & 0x3ff) << 10 | key.charCodeAt(++i) & 0x3ff);
                    bytes[index++] = 0xf0 | code >>> 18;
                    bytes[index++] = 0x80 | code >>> 12 & 0x3f;
                    bytes[index++] = 0x80 | code >>> 6 & 0x3f;
                    bytes[index++] = 0x80 | code & 0x3f;
                }
            }
            key = bytes;
        }
        if (key.length > 64) key = new Md5(true).update(key).array();
        var oKeyPad = [], iKeyPad = [];
        for(i = 0; i < 64; ++i){
            var b = key[i] || 0;
            oKeyPad[i] = 0x5c ^ b;
            iKeyPad[i] = 0x36 ^ b;
        }
        Md5.call(this, sharedMemory);
        this.update(iKeyPad);
        this.oKeyPad = oKeyPad;
        this.inner = true;
        this.sharedMemory = sharedMemory;
    }
    HmacMd5.prototype = new Md5();
    HmacMd5.prototype.finalize = function() {
        Md5.prototype.finalize.call(this);
        if (this.inner) {
            this.inner = false;
            var innerHash = this.array();
            Md5.call(this, this.sharedMemory);
            this.update(this.oKeyPad);
            this.update(innerHash);
            Md5.prototype.finalize.call(this);
        }
    };
    var exports = createMethod();
    exports.md5 = exports;
    exports.md5.hmac = createHmacMethod();
    if (COMMON_JS) module.exports = exports;
    else {
        /**
     * @method md5
     * @description Md5 hash function, export to global in browsers.
     * @param {String|Array|Uint8Array|ArrayBuffer} message message to hash
     * @returns {String} md5 hashes
     * @example
     * md5(''); // d41d8cd98f00b204e9800998ecf8427e
     * md5('The quick brown fox jumps over the lazy dog'); // 9e107d9d372bb6826bd81d3542a419d6
     * md5('The quick brown fox jumps over the lazy dog.'); // e4d909c290d0fb1ca068ffaddf22cbd0
     *
     * // It also supports UTF-8 encoding
     * md5('中文'); // a7bac2239fcdcb3a067903d8077c4a07
     *
     * // It also supports byte `Array`, `Uint8Array`, `ArrayBuffer`
     * md5([]); // d41d8cd98f00b204e9800998ecf8427e
     * md5(new Uint8Array([])); // d41d8cd98f00b204e9800998ecf8427e
     */ root.md5 = exports;
        if (AMD) define(function() {
            return exports;
        });
    }
})();

});
parcelRegister("kjyEk", function(module, exports) {
"use strict";

});



parcelRegister("bt9VR", function(module, exports) {

$parcel$export(module.exports, "default", () => $859a1b80e4a273a1$export$2e2bcd8739ae039);
class $859a1b80e4a273a1$export$2e2bcd8739ae039 extends CustomEvent {
    static show(pSpinnerId) {
        const spinnerEvent = new $859a1b80e4a273a1$export$2e2bcd8739ae039({
            cmd: "show",
            spinnerId: pSpinnerId
        });
        window.dispatchEvent(spinnerEvent);
    }
    static hide(pSpinnerId) {
        const spinnerEvent = new $859a1b80e4a273a1$export$2e2bcd8739ae039({
            cmd: "hide",
            spinnerId: pSpinnerId
        });
        window.dispatchEvent(spinnerEvent);
    }
    constructor(p){
        super("spinnerEvent", {
            detail: {
                cmd: p.cmd,
                id: p.spinnerId
            }
        });
    }
}

});


parcelRegister("kN0e5", function(module, exports) {

module.exports = Promise.all([
    import("2ZaqD"),
    (parcelRequire("fFMZG"))(import.meta.resolve("gL66t")),
    import("k4tVn")
]).then(()=>parcelRequire('anzwo'));

});
parcelRegister("fFMZG", function(module, exports) {
"use strict";

var $lovBw = parcelRequire("lovBw");
module.exports = $lovBw(function(bundle) {
    return new Promise(function(resolve, reject) {
        if (typeof document === 'undefined') return resolve();
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = bundle;
        // Don't insert the same link element twice (e.g. if it was already in the HTML)
        var existingLinks = document.getElementsByTagName('link');
        if (Array.from(existingLinks).some(function(existing) {
            return existing.href === link.href && existing.rel.indexOf('stylesheet') > -1;
        })) {
            resolve();
            return;
        }
        link.onerror = function(e) {
            link.onerror = link.onload = null;
            link.remove();
            reject(e);
        };
        link.onload = function() {
            link.onerror = link.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(link);
    });
});

});
parcelRegister("lovBw", function(module, exports) {
"use strict";
var $f9345ad2c034f768$var$cachedBundles = {};
var $f9345ad2c034f768$var$cachedPreloads = {};
var $f9345ad2c034f768$var$cachedPrefetches = {};
function $f9345ad2c034f768$var$getCache(type) {
    switch(type){
        case 'preload':
            return $f9345ad2c034f768$var$cachedPreloads;
        case 'prefetch':
            return $f9345ad2c034f768$var$cachedPrefetches;
        default:
            return $f9345ad2c034f768$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $f9345ad2c034f768$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});



parcelRegister("a77kw", function(module, exports) {


module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("eWKty")),
    import("a5GY2"),
    import("2ZaqD"),
    (parcelRequire("fFMZG"))(import.meta.resolve("gL66t")),
    import("k4tVn"),
    import("b0fpy")
]).then(()=>parcelRequire('cZAV9'));

});

parcelRegister("46a9y", function(module, exports) {

module.exports = Promise.all([
    (parcelRequire("fFMZG"))(import.meta.resolve("dPa9X")),
    import("2ZaqD"),
    import("9rM08")
]).then(()=>parcelRequire('cXDx4'));

});





var $6Ceg9 = parcelRequire("6Ceg9");

var $1ssWT = parcelRequire("1ssWT");
class $ab4d5fa532a37961$export$2e2bcd8739ae039 {
    static addHeadLink(p) {
        const link = document.createElement("link");
        Object.entries(p).forEach(([name, value])=>{
            link[name] = value;
        });
        document.head.appendChild(link);
        return link;
    }
    static setFavIcon(pIconURL) {
        if (!pIconURL) return;
        this.addHeadLink({
            rel: "icon",
            sizes: "180x180",
            href: pIconURL
        });
        this.addHeadLink({
            rel: "apple-touch-icon",
            href: pIconURL
        });
    }
}


class $0b41b0f7ebefb881$export$2e2bcd8739ae039 {
    static getURL() {
        return "https://www.googletagmanager.com/gtag/js";
    }
    gtag() {
        if (!this.isLoaded) return;
        this.showDebug("gtag", arguments);
        window.dataLayer.push(arguments);
    }
    showDebug(pFunction, pArgs) {
        if (this.debug) console.log(pFunction, pArgs);
    }
    event(pName, pOptions) {
        this.gtag("event", pName, pOptions);
    }
    pageView(pOptions) {
        this.gtag("event", "page_view", pOptions);
    }
    load() {
        return new Promise((resolve, reject)=>{
            if (!this.isActive) {
                this.showDebug("loader", "Analytics Inactive");
                return resolve();
            }
            const script = document.createElement("script");
            script.src = $0b41b0f7ebefb881$export$2e2bcd8739ae039.getURL() + "?id=" + this.tag;
            script.async = true;
            script.onload = ()=>{
                this.isLoaded = true;
                window.dataLayer = window.dataLayer || [];
                this.gtag("js", new Date());
                this.gtag("config", this.tag, this.config);
                this.showDebug("loader", "Analytics tag: " + this.tag);
                resolve();
            };
            script.onerror = ()=>{
                console.log("GANA Error Loading");
                resolve();
            };
            document.head.appendChild(script);
        });
    }
    setConfig(p) {
        if (!this.isLoaded) {
            this.url = p.url;
            this.tag = p.tag;
            this.config = p.config;
        }
    }
    constructor(p){
        Object.entries(p).forEach(([id, value])=>{
            this[id] = value;
        });
        window.addEventListener("ganaEvent", (pEvt)=>{
            this.event(pEvt.detail.name, pEvt.detail.options);
        });
    }
}



var $kmaCx = parcelRequire("kmaCx");


var $1ssWT = parcelRequire("1ssWT");
class $c9f9e1944d3041b4$export$2e2bcd8739ae039 extends (0, $1ssWT.default) {
    show(pModule) {
        window.document.body.classList.add("ed-scroll-block");
        this.container.children.unrender();
        this.container.children.append(pModule);
        this.classList.remove("ed-hidden");
    }
    hide() {
        window.document.body.classList.remove("ed-scroll-block");
        this.classList.add("ed-hidden");
        this.container.children.unrender();
    }
    constructor(p){
        super(p);
        this.analytics = p.analytics;
        this.classList.add("ed-app-popup");
        this.classList.add("ed-hidden");
        this.children.append([
            new (0, $1ssWT.default)({
                store: (pEl)=>{
                    this.container = pEl;
                },
                class: "ed-popup-container"
            })
        ]);
        window.addEventListener("popUpEvent", (pEvt)=>{
            if (pEvt.detail.cmd === "show") {
                this.show(pEvt.detail.module);
                return;
            }
            this.hide();
        });
    }
}



var $dPc8B = parcelRequire("dPc8B");
class $b89a7ef79e30d8a0$export$2e2bcd8739ae039 extends (0, $6Ceg9.default) {
    async autoReload() {
        console.log("autoReload");
        const reload = await this.router.newVersion();
        if (reload) window.location.reload();
    }
    render() {
        this.analytics.load().then(()=>{
            super.render();
            this.analytics.event("app_init");
            this.router.go(window.location.href).then(()=>{
                const apiUser = new (0, $dPc8B.default)({
                    jwtKey: this.config.origin.apiClient.auth.jwtKey
                });
            });
        });
    }
    show(pModule) {
        this.appBody.children.unrender();
        this.appBody.children.append(pModule);
    }
    setOrigin() {
        const origin = this.config.origins[window.location.origin];
        this.config.origin = typeof origin === "undefined" ? this.config.origins.default : origin;
        this.analytics = new (0, $0b41b0f7ebefb881$export$2e2bcd8739ae039)(this.config.origin.analytics);
    }
    getRouter(pClass) {
        return new pClass({
            onOpen: (pModule)=>{
                this.show(pModule);
            },
            config: this.config
        });
    }
    buildStructure() {
        this.children.append([
            new (0, $kmaCx.default)({
                spinnerId: "main"
            }),
            new (0, $c9f9e1944d3041b4$export$2e2bcd8739ae039)({}),
            new (0, $1ssWT.default)({
                class: "ed-app-body",
                store: (pEl)=>{
                    this.appBody = pEl;
                }
            })
        ]);
    }
    setFavIcon(pURL) {
        (0, $ab4d5fa532a37961$export$2e2bcd8739ae039).setFavIcon(pURL);
    }
    constructor(p){
        super(p);
        this.classList.add("ed-app");
        this.version = p.version;
        this.config = p.config;
        this.setOrigin();
        this.router = this.getRouter(p.router);
        this.buildStructure();
        if (this.config.origin.isDevEnv) return;
        if (this.config.autoUpdate >= 5000) this.updateInterval = setInterval(()=>{
            this.autoReload();
        }, this.config.autoUpdate);
    }
}



var $bJkGa = parcelRequire("bJkGa");

var $1sSWl = parcelRequire("1sSWl");

var $kgaiw = parcelRequire("kgaiw");
class $fe3238b3c6ac9d77$export$2e2bcd8739ae039 {
    async newVersion() {
        if (this.config.origin.isDevEnv) return false;
        let verData;
        try {
            const response = await fetch(window.location.origin + "/version.json?preview=true");
            verData = await response.json();
            return verData.version !== Version;
        } catch (error) {
            return false;
        }
    }
    updateModule(pClass, pParams, pApiResult) {
        if (this.currentModule?.constructor.name === pClass) return this.currentModule.update(pParams);
        if (this.currentModule) {
            this.currentModule.removeMeta();
            this.currentModule.removeLinkCanonical();
        }
    }
    newModule(pModSrc, pParams) {
        const modClass = new pModSrc.default({
            params: pParams
        });
        this.currentModule = modClass;
        return this.currentModule;
    }
    async route(pURL, pParams) {
        this.getPageFunction = this.staticRoutes[pURL];
        if (typeof this.getPageFunction !== "undefined") return this.getPageFunction(pParams);
        if (!this.config.routerEndPoint) {
            const error = new Error("Error 404");
            error.code = 404;
            error.type = "route";
            error.url = pURL;
            this.getPageFunction = this.staticRoutes["404"];
            pParams.error = error;
            return this.getPageFunction(pParams);
        }
        const module = await this.routeAPI(pURL, pParams);
        return module;
    }
    getAPIResult(pViewResult, pParams) {
        const url = pViewResult?.Results?.URL?.Payload;
        if (!url) return {
            module: "URL"
        };
        const params = {
            module: url.Module
        };
        if (typeof pParams === "object" && pParams !== null) Object.assign(params, pParams);
        Object.entries(pViewResult.Results).forEach(([resultId, result])=>{
            if (result.Payload) params[resultId] = result.Payload;
        });
        return params;
    }
    async routeAPI(pURL, pParams) {
        const apiClient = new (0, $kgaiw.default)(this.config.origin.apiClient);
        return apiClient.fetch({
            endPoint: this.config.routerEndPoint + "" + pURL
        }).then((viewResult)=>{
            const apiResult = this.getAPIResult(viewResult, pParams);
            if (apiResult) {
                this.getPageModule = this.apiModules[apiResult.module];
                if (typeof this.getPageModule !== "undefined") return this.getPageModule(apiResult);
            }
            const error = new Error("Missing Module " + apiResult.module);
            error.code = 999;
            error.type = "module";
            error.module = apiResult.module;
            throw error;
        }).catch((error)=>{
            if (error.type === "fetch" && error.code === 401) return this.link("/login" + window.location.search, {
                nextURL: pURL,
                error: error
            });
            if (error.type === "fetch" && error.code === 404) {
                this.getPageFunction = this.staticRoutes["404"];
                error.url = pURL;
                return this.getPageFunction({
                    searchParams: pParams,
                    error: error
                });
            }
            throw error;
        });
    }
    async link(pURL, pParams) {
        if (await this.newVersion()) {
            window.location.assign(pURL);
            return;
        }
        if (pURL.toLowerCase() != window.location.pathname.toLowerCase()) {
            window.history.pushState(this.state, null, pURL);
            this.go(pURL, pParams);
            return;
        }
    }
    async go(pURL, pParams) {
        const params = {};
        const url = new URL(pURL, window.location.origin);
        if (url.searchParams.size > 0) {
            params.searchParams = {};
            url.searchParams.forEach((value, key)=>{
                params.searchParams[key] = value;
            });
        }
        if (typeof pParams === "object" && pParams !== null) Object.assign(params, pParams);
        this.route(url.pathname, params).then((pModule)=>{
            if (pModule) this.onOpen(pModule);
        });
    }
    constructor(p){
        this.onOpen = p.onOpen;
        this.config = p.config;
        this.state = {};
        window.addEventListener("popstate", (pEvt)=>{
            this.go(window.location.href);
        });
        window.addEventListener("anchorEvent", (pEvt)=>{
            if (pEvt.detail.type === "link") {
                this.link(pEvt.detail.href, pEvt.detail.params);
                return;
            }
            this.go(pEvt.detail.href, pEvt.detail.params);
        });
        this.staticRoutes = {};
        this.apiModules = {};
    }
}


parcelRequire("kgaiw");



class $ec21e313d7455312$export$2e2bcd8739ae039 extends (0, $fe3238b3c6ac9d77$export$2e2bcd8739ae039) {
    async getPageWeb(pParams, pApiResult) {
        if (this.updateModule("PageWeb", pParams, pApiResult)) return;
        const modSrc = await (parcelRequire("kN0e5"));
        return this.newModule(modSrc, pParams, pApiResult);
    }
    async getPageWebHero(pParams, pApiResult) {
        if (this.updateModule("PageWebHero", pParams, pApiResult)) return;
        const modSrc = await (parcelRequire("a77kw"));
        return this.newModule(modSrc, pParams, pApiResult);
    }
    async getPage404(pParams) {
        const modSrc = await (parcelRequire("46a9y"));
        return this.newModule(modSrc, pParams);
    }
    constructor(p){
        super(p);
        this.staticRoutes = {
            "404": this.getPage404,
            "/login": this.getPageLogin,
            "/unathorized": this.getPageUnAuth,
            "/": this.getPageShowcase
        };
        this.apiModules = {
            "PageWeb": this.getPageWeb,
            "PageWebHero": this.getPageWebHero
        };
    }
}


var $aa562db9cb4751f7$exports = {};
$aa562db9cb4751f7$exports = import.meta.resolve("igbWC");


class $0344492505fddfa2$export$2e2bcd8739ae039 extends (0, $b89a7ef79e30d8a0$export$2e2bcd8739ae039) {
    constructor(p){
        super({
            config: (0, $bJkGa.default),
            version: (0, $1sSWl.default),
            router: (0, $ec21e313d7455312$export$2e2bcd8739ae039),
            parent: p.parent
        });
        this.setFavIcon(new URL($aa562db9cb4751f7$exports));
    }
}


const $ffd94e1d81f19b1c$var$app = new (0, $0344492505fddfa2$export$2e2bcd8739ae039)({
    parent: document.getElementById("ed-app-root")
});
$ffd94e1d81f19b1c$var$app.render();


//# sourceMappingURL=js-app.eb00bae9.js.map
